// stories
import pageOne from "./pageContent/pageOne";
import WelcomePage from "./pageContent/Welcome";
import pageTwoA from "./pageContent/pageTwoA";
import pageTwoB from "./pageContent/pageTwoB";
import pageTwoC from "./pageContent/pageTwoC";
import pageTwo from "./pageContent/pageTwo";
import pageThree from "./pageContent/pageThree";
import pageFour from "./pageContent/pageFour";
import pageFive from "./pageContent/pageFive";
import BackCover from "./pageContent/BackCover";

const state = {
  baseUrl: "/webfolder/assets/ebook/ytt-magazine/",
  navigationDirection: 1,
  pageContent: [
    pageOne,
    WelcomePage,
    pageTwo,
    pageThree,
    pageFour,
    pageFive,
    pageTwoA,
    pageTwoB,
    pageTwoC,
    BackCover
  ],
  activeContent: null,
  currentPage: 1,
  managingCookies: false,

  // to intercept back/forward browser clicks
  navigatingPages: false,
  readingContent: false,
  closeContent: false
};

export default state;
